import React from 'react'
import { ErfResponse } from '../../../api/bridgingFinance/searchPropertyByErf'
import { SchemeOwnerResponse } from '../../../api/bridgingFinance/searchSchemeOwnersList'
import '../SearchResultsTable.css'

export interface SchemeOwnersListResultsTableProps {
  entries: SchemeOwnerResponse[]
  title: string
  onRowClick?: (row: SchemeOwnerResponse) => void
}

export const SchemeOwnersListResultsTable: React.FC<
  SchemeOwnersListResultsTableProps
> = ({ entries, title, onRowClick }) => {
  const handleClick = (erf: SchemeOwnerResponse) => () => {
    if (onRowClick) onRowClick(erf)
  }

  return (
    <div className="kyc-bf-results-table-container">
      <h3 className="table-title">{title}</h3>
      <table>
        <thead>
          <tr style={{ height: '40px' }}>
            <th style={{ width: '70px' }}>Section #</th>
            <th style={{ width: '70px' }}>Flat #</th>
            <th style={{ width: '250px' }}>Owners Name</th>
            <th>Extent</th>
            <th>Type</th>
            {/* <th>Allotment</th>
          <th>CMA ID</th> */}
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, index) => (
            <tr
              key={index}
              onClick={handleClick(entry)}
              style={{ height: '30px' }}
            >
              <td style={{ width: '70px' }}>{entry.sectionNo}</td>
              <td style={{ width: '70px' }}>{entry.flatNo || '-'}</td>
              <td style={{ width: '250px' }}>{entry.owner}</td>
              <td>{entry.sectionExtent}</td>
              <td>{entry.type || '-'}</td>
              {/* <td>{entry.allotment}</td>
            <td>{entry.cmaid}</td> */}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
